module.exports = __webpack_public_path__ + "static/src/content/images/processed/200/The-Stuarts-A-Bloody-Reign.a680bc9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/200/The-Stuarts-A-Bloody-Reign.jpg
// module id = Hy7N
// module chunks = 0